import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=0cf045bc&scoped=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=ts"
export * from "./StatusIndicator.vue?vue&type=script&lang=ts"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=0cf045bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf045bc",
  null
  
)

export default component.exports